module.exports = __webpack_public_path__ + "static/media/woman.f8deff8c.jpg";